export const notificationMixin = {
    methods: {
        showNotification(settings) {
            /*
            title: Заголовок уведомления.
            tag: Тег уведомления. Уведомления с одинаковым тегом будут объединены в одно, что позволяет избежать перегрузки панели уведомлений.
            data: Дополнительные данные, которые будут доступны в обработчике события клика на уведомление.
            requireInteraction: Булевое значение, указывающее, должно ли уведомление оставаться видимым, пока пользователь не закроет его.
            silent: Булевое значение, указывающее, должно ли уведомление быть тихим или проигрывать звук.
            vibrate: Массив чисел, определяющий пульсацию уведомления на устройствах с поддержкой вибрации.
            image: Путь к изображению, которое должно быть отображено в уведомлении.
            actions: Массив объектов NotificationAction, представляющих действия, доступные в уведомлении.

            body: 'Текст уведомления',
            icon: 'путь_к_изображению_иконки',
            tag: 'my-notification-tag',
            requireInteraction: true,
            silent: true,
            image: 'путь_к_изображению',
            actions: [
            { action: 'accept', title: 'Принять' },
            { action: 'reject', title: 'Отклонить' }
            ]
            let svgImage = '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><circle cx="50" cy="50" r="40" stroke="black" stroke-width="3" fill="red" /></svg>';

            let notification = new Notification('Заголовок уведомления', {
            body: 'Текст уведомления',
            icon: 'data:image/svg+xml,' + encodeURIComponent(svgImage),
            });
              */
            let title = ''
            if (settings.title) {
                title = settings.title;
            }
            let notifyOptions = {};
            if (settings.notifyOptions) {
                notifyOptions = settings.notifyOptions;
            }
            let urlOpen = '';
            if (settings.urlOpen) {
                urlOpen = settings.urlOpen;
            }
            if ('Notification' in window) {
                Notification.requestPermission().then(function (permission) {
                    if (permission === 'granted') {
                        let notification = new Notification(title,
                            notifyOptions);
                        if(urlOpen !== ''){
                            notification.onclick = function (event) {
                                event.preventDefault();
                                //в той же закладке, где открыт сайт
                                window.focus();
                                window.location.href=urlOpen;
                                //новая закладка
                                //window.open(urlOpen);
                            }
                        }
                    }
                });
            }
        }
    }
}
